'use strict';
const angular = require('angular');
const {isFunction, isObject} = angular;

export function $$ObservableArrayListenerProvider() {
  return {
    $get: [
      'AbstractEventListener',
      'ObservableArrayFactory',
      function (
        AbstractEventListener,
        ObservableArrayFactory,
      ) {
        function ObservableArrayListener(reference, eventType, callback, context, options) {
          if (!isObject(reference) || !isFunction(reference.addListener)) {
            throw new Error('ObservableArrayListener: reference must be a valid ObservableArray!');
          }
          options = isObject(options) ? options : {};

          Object.defineProperties(this, {
            reference: {configurable: false, enumerable: false, writable: false, value: reference}
          });

          AbstractEventListener.call(this, ObservableArrayListener, {
            callback: callback,
            eventType: eventType,
            context: context,
            id: options.id,
            start: options.start
          });
        }

        AbstractEventListener.__inheritFrom(ObservableArrayListener, {
          eventTypes: ObservableArrayFactory.EVENT_TYPES,
          create: create,
          destroy: destroy
        });

        // initialization logic goes here. on complete, it is replaced with resume.
        function create() {
          this.reference.addListener(this.eventType, this.callback, this.context);
        }

        function destroy() {
          this.reference.removeListener(this.eventType, this.callback);
        }

        return ObservableArrayListener;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/ObservableArrayListener.js